import React, { useEffect, useRef } from 'react';
import { TitleScreen } from './components/TitleScreen';
import { Prologue } from './components/Prologue';
import { RoomView } from './components/RoomView';
import { PuzzleModal } from './components/PuzzleModal';
import { Inventory } from './components/Inventory';
import { HUD } from './components/HUD';
import { ScreenEffects } from './components/ScreenEffects';
import { EndingScreen } from './components/EndingScreen';
import { useGameStore, useGameActions } from './hooks/useGameStore';

const App: React.FC = () => {
  const state = useGameStore();
  const actions = useGameActions();
  const bgm = useRef(new Audio('/audio/bgm.mp3'));

  useEffect(() => {
    bgm.current.loop = true;
  }, []);

  useEffect(() => {
    bgm.current.volume = state.bgmVolume;
  }, [state.bgmVolume]);

  useEffect(() => {
    if (state.phase === 'playing') {
      bgm.current.play().catch(() => {});
    } else {
      bgm.current.pause();
      bgm.current.currentTime = 0;
    }
  }, [state.phase]);

  return (
    <div style={{
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
      background: '#0a0a0a',
      userSelect: 'none',
    }}>
      {state.phase === 'title' && (
        <TitleScreen
          onStart={actions.startGame}
          onLoad={actions.loadGame}
        />
      )}

      {state.phase === 'prologue' && (
        <Prologue onComplete={actions.startPlaying} />
      )}

      {state.phase === 'playing' && (
        <>
          <RoomView />
          <Inventory />
          <HUD />
          {state.activePuzzle && <PuzzleModal />}
        </>
      )}

      {state.phase === 'ending' && (
        <EndingScreen />
      )}

      <ScreenEffects />
    </div>
  );
};

export default App;
